import React from "react";
import "./AppSkeleton.css";

const AppSkeleton = () => {
  return (
    <div className="app-skeleton" aria-hidden="true">
      <aside className="app-skeleton__quick">
        {Array.from({ length: 6 }).map((_, index) => (
          <span key={index} className="app-skeleton__quick-dot app-skeleton__shine" />
        ))}
      </aside>

      <aside className="app-skeleton__sources">
        <span className="app-skeleton__search app-skeleton__shine" />
        {Array.from({ length: 9 }).map((_, index) => (
          <div key={index} className="app-skeleton__source-row">
            <span className="app-skeleton__source-icon app-skeleton__shine" />
            <span className="app-skeleton__source-line app-skeleton__shine" />
          </div>
        ))}
      </aside>

      <main className="app-skeleton__main">
        {Array.from({ length: 6 }).map((_, index) => (
          <article key={index} className="app-skeleton__card">
            <span className="app-skeleton__image app-skeleton__shine" />
            <div className="app-skeleton__content">
              <span className="app-skeleton__title app-skeleton__shine" />
              <span className="app-skeleton__title app-skeleton__title--short app-skeleton__shine" />
              <span className="app-skeleton__text app-skeleton__shine" />
              <span className="app-skeleton__text app-skeleton__text--short app-skeleton__shine" />
              <span className="app-skeleton__meta app-skeleton__shine" />
            </div>
          </article>
        ))}
      </main>
    </div>
  );
};

export default AppSkeleton;
